import 'nodelist-foreach-polyfill';

export default class {
  constructor(options = {}) {
    this.options = {
      selectors: {
        trigger: '.table-scroll',
        hint: '.table-animation'
      },
      classes: {
        hintActive: 'table-animation--active'
      },
      ...options,
    };

    this.$tableScrolls = document.querySelectorAll(this.options.selectors.trigger);

    if (this.$tableScrolls.length > 0) {

      this.$tableScrolls.forEach((tableScroll) => {
        if (this.checkScrollWidth(tableScroll)){
          let hint = tableScroll.querySelector(this.options.selectors.hint);

          if (!hint) return;

          this.show(hint);
          this.bindEvents(tableScroll)
        }
      });
    }
  }

  checkScrollWidth(tableScroll) {
    if (tableScroll.scrollWidth > tableScroll.offsetWidth) {
      return true;
    }

    return false;
  }

  bindEvents(tableScroll) {
    tableScroll.addEventListener('touchmove', event => this.hideScrollHint(event));
  }

  hideScrollHint(event) {
    const table = event.currentTarget;
    const hint = table.querySelector(this.options.selectors.hint);
    this.hide(hint);
  }

  show(hint){
    hint.classList.add(this.options.classes.hintActive);
  }

  hide(hint) {
    hint.classList.remove(this.options.classes.hintActive);
  }
}
